import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	deletePlanDescription: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete-plan-description',
		defaultMessage:
			'Please confirm that you want to permanently delete the plan <strong>{planTitle}</strong>.',
		description: 'Plan deletion dialog content',
	},
	deletePlanHeading: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete-plan-heading',
		defaultMessage: 'Delete plan',
		description: 'Plan deletion dialog heading',
	},
	delete: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete',
		defaultMessage: 'Delete',
		description: 'Label for button that allows users to delete the plan',
	},
	configure: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.configure',
		defaultMessage: 'Configure',
		description: 'Label for button that allows users to configure the plan',
	},
	duplicate: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.duplicate',
		defaultMessage: 'Duplicate',
		description: 'Label for button that allows users to duplicate the plan',
	},
	takeTour: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.take-tour',
		defaultMessage: 'Take tour',
		description: 'Label for menu item to start the onboarding tour',
	},
	helpLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.help-link',
		defaultMessage: 'Get help',
		description: 'Label for help link',
	},
	planSettings: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.plan-settings',
		defaultMessage: 'Plan settings',
		description: 'Label for plan settings dropdown menu button',
	},
	planDuplicatedFlagError: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.plan-duplicated-flag-error',
		defaultMessage: 'There was an error when trying to duplicate your plan',
		description:
			'Message to be shown in the flag when the plan was not duplicated due to an error.',
	},
});

export default messages;
